import {BreadCrumb} from "primereact/breadcrumb";
import Icon from "../../system/components/icon";
import PageHeaderButton from "../components/page-header-button";
import {TabPanel, TabView} from "primereact/tabview";
import React, {useEffect, useState} from "react";
import {useTranslate} from "../../system/useTranslate";
import {useNavigate, useSearchParams} from "react-router-dom";
import AccessControl from "./tabs/access-control";
import ManageMembers from "./tabs/manage-members";
import {usePermission} from "../../system/usePermission";
import ProfileSetting from "./tabs/profile-setting";
import SelectableTabsButton, {useSelectableTabs} from "../components/selectable-tabs-button";
import WorkspaceSettings from "./tabs/workspace-settings";
import PlatformConnection from "./tabs/platform-connection";
import {useWorkspaceRole} from "../../system/use-workspace-role";

function Index(props) {

    const [activeIndex,setActiveIndex] = useState(0);
    const [breadCrumb,setBreadCrumbData] = useState([]);
    const translate = useTranslate();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const permission = usePermission();
    const {role: workspaceRole} = useWorkspaceRole();

    const tabs = [
        { id: "user-profile", label: "profile", icon: "mi mi:account_circle", view:ProfileSetting },
        { id: "access-control", label: "access-control", icon: "mi mi:shield_lock", view:AccessControl, visible:permission.can("workspace.roles.manage") },
        { id: "manage-members", label: "manage-members", icon: "mi mi:groups", view:ManageMembers, visible:permission.can("workspace.members.manage") },
        { id: "workspace-settings", label: "workspace-settings", icon: "mi mi:settings", view:WorkspaceSettings, visible:workspaceRole === "owner" },
        { id: "platform-connection", label: "platform-connection", icon: "mi mi:link", view:PlatformConnection, visible:workspaceRole === "owner" },
    ].filter((tab) => tab.visible !== false);
    const selectableTabs = useSelectableTabs(tabs, "visible-tabs:settings", activeIndex, setActiveIndex);
    const visibleTabs = selectableTabs.visibleTabs;
    const {selectedIds, toggleTab} = selectableTabs;
    const requestedTab = searchParams.get("tab");
    const requestedTabIndex = visibleTabs.findIndex((tab) => tab.id === requestedTab);

    useEffect(() => {
        if (!requestedTab || requestedTabIndex < 0) return;
        setActiveIndex(requestedTabIndex);
    }, [requestedTab, requestedTabIndex]);

    useEffect(()=>{
        setBreadCrumbData([
            {label:translate("settings"), command:()=>{navigate("/settings")}}
        ]);
    },[navigate, translate]);

    return(
        <div className="h-full overflow-hidden flex flex-column">
            <BreadCrumb separatorIcon={<Icon icon="mi mi:chevron_left text-xs"/>} className="bg-transparent border-none text-xs" model={breadCrumb}/>
            <PageHeaderButton title={props.name} description={props.description} />
            {/* تب‌ها */}
            <div className="flex-1 min-h-0 flex flex-column relative">
                <SelectableTabsButton tabs={tabs} selectedIds={selectedIds} onChange={toggleTab} className="absolute z-5" style={{top: ".45rem", left: ".75rem"}}/>
                <TabView lazy activeIndex={activeIndex} onTabChange={(e)=>{setActiveIndex(e.index);
                    setBreadCrumbData(prv=>{
                        const next = Array.isArray(prv) ? [...prv] : [];
                        next[1] = {label:translate(visibleTabs[e.index].label)};
                        return next;
                    });
                }} panelContainerClassName="flex-1 min-h-0 overflow-hidden p-0 border-noround" className="h-full flex flex-column">
                    {visibleTabs.map((tab, tabIndex) => {
                        const TabContent = tab.view;
                        return (
                        <TabPanel
                            key={tab.id}
                            header={translate(tab.label)}
                            disabled={tab.disabled}
                            leftIcon={<Icon icon={tab.icon} className="pl-2" />}
                            className="h-full text-xs">
                            {tabIndex === activeIndex && <div className="h-full min-h-0 overflow-auto">
                                <TabContent/>
                            </div>}
                        </TabPanel>
                    )})}
                </TabView>
            </div>
        </div>
    )
}



export default Index;
